import React, { Component, Fragment } from 'react';
import {
    withRouter
} from 'react-router-dom';
import lpApp from '../../app/lp_app';
import { TitleShimmer, ParagraphShimmer } from './../misc/shimmer';

import { connect } from 'react-redux';
import { LP_STATE_WIZARD, setAppState } from '../../redux/actions/app_state';
import { lpPattern, P_BACK } from '../../tracking/pattern_detector';
import LpPacks from './packs';


class PacksWrapper extends Component {
    constructor(props) {
        super(props);
        lpApp.mainCheckout(
          this.props.match.params.name,
          this.props.match.params.id ? this.props.match.params.id : ''
        );
    }

    render () {
        return (
            <div>
                {(this.props.pricing_loading) ?
                    <ParagraphShimmer /> :
                    <LpPacks />
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    pricing_loading: state.loading_details.pricing
});

const mapDispatchToProps = dispatch => ({
    goBack: () => {
        dispatch(setAppState(LP_STATE_WIZARD));
        // #event
        lpevents.track('Modifier mon document', {});
        lpPattern.trackLastAction(P_BACK);
        lpPattern.sendAndResetTracker();
    }
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PacksWrapper));



// WEBPACK FOOTER //
// ./src/components/buy/packs_wrapper.js